import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { APP_CONFIG_BROWSER } from './app/app.config.browser';

const trustedTypes = document.defaultView?.trustedTypes;
if (trustedTypes?.createPolicy) {
  trustedTypes.createPolicy('default', {
    createHTML: (html: string) => html,
    createScriptURL: (url: string) => {
      if (url.endsWith('ngsw-worker.js')) return url;
      if (isDevMode() && url.startsWith('blob:')) return url;
      throw new TypeError(`Untrusted script URL: ${url}`);
    },
  });
}

try {
  await bootstrapApplication(App, APP_CONFIG_BROWSER);
} catch (error) {
  console.error(error);
}
